import script from "./NumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberInput.vue?vue&type=script&setup=true&lang=js"

import "./NumberInput.vue?vue&type=style&index=0&id=42fc2deb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fc2deb"]])

export default __exports__